import * as React from "react";
import { AmplifyTheme, ForgotPassword } from "aws-amplify-react";
import {
  Input,
  FormSection,
  SectionHeader,
  SectionBody,
  SectionFooter,
  Button,
  Link,
  SectionFooterPrimaryContent,
  SectionFooterSecondaryContent
} from "aws-amplify-react/dist/Amplify-UI/Amplify-UI-Components-React";

import { auth } from "aws-amplify-react/dist/Amplify-UI/data-test-attributes";

import { I18n } from "aws-amplify";

export default class CustomForgotPassword extends ForgotPassword {
  constructor(props) {
    super(props);

    this.send = this.send.bind(this);
    this.submit = this.submit.bind(this);

    this._validAuthStates = ["forgotPassword"];
    this.state = { delivery: null };
  }

  handleInputChange(evt) {
    this.inputs = this.inputs || {};
    const { name, value, type, checked } = evt.target;
    const check_type = ["radio", "checkbox"].includes(type);
    const nameWithoutRandomPart = name.split("?")[0];
    this.inputs[nameWithoutRandomPart] = check_type ? checked : value;
    this.inputs.checkedValue = check_type ? value : null;
  }

  submitView() {
    const theme = this.props.theme || AmplifyTheme;
    return (
      <div>
        <Input
          placeholder={I18n.get("Code")}
          theme={theme}
          key="code"
          name="code?ajsdkjasdhasljdhasdjla"
          autoComplete="new-password"
          onChange={this.handleInputChange}
        />
        <Input
          placeholder={I18n.get("New Password")}
          theme={theme}
          type="password"
          key="password"
          name="password?nxsanxasnx"
          autoComplete="new-password"
          onChange={this.handleInputChange}
        />
      </div>
    );
  }

  showComponent(theme) {
    const { authData = {} } = this.props;
    // if (hide && hide.includes(ForgotPassword)) {
    //   return null;
    // }

    return (
      <FormSection theme={theme} data-test={auth.forgotPassword.section}>
        <SectionHeader theme={theme} data-test={auth.forgotPassword.headerSection}>
          {I18n.get("Reset your password")}
        </SectionHeader>
        <SectionBody theme={theme} data-test={auth.forgotPassword.bodySection}>
          {this.state.delivery || authData.username ? this.submitView() : this.sendView()}
        </SectionBody>
        <SectionFooter theme={theme}>
          <SectionFooterPrimaryContent theme={theme}>
            {this.state.delivery || authData.username ? (
              <Button theme={theme} onClick={this.submit} data-test={auth.forgotPassword.submitButton}>
                {I18n.get("Submit")}
              </Button>
            ) : (
              <Button theme={theme} onClick={this.send} data-test={auth.forgotPassword.sendCodeButton}>
                {I18n.get("Send Code")}
              </Button>
            )}
          </SectionFooterPrimaryContent>
          <SectionFooterSecondaryContent theme={theme}>
            {this.state.delivery || authData.username ? (
              <Link theme={theme} onClick={this.send} data-test={auth.forgotPassword.resendCodeLink}>
                {I18n.get("Resend Code")}
              </Link>
            ) : (
              <Link theme={theme} onClick={() => this.changeState("signIn")} data-test={auth.forgotPassword.backToSignInLink}>
                {I18n.get("Back to Sign In")}
              </Link>
            )}
          </SectionFooterSecondaryContent>
        </SectionFooter>
      </FormSection>
    );
  }
}
